const EUROPEAN_THOUSAND_GROUPS_PATTERN = /^\d{1,3}(\.\d{3})+$/;
const US_THOUSAND_GROUPS_PATTERN = /^\d{1,3}(,\d{3})+$/;

/**
 * Parses a user-entered number that may use European (1.234,56) or US (1,234.56)
 * grouping. When both separators appear, the rightmost one is the decimal mark.
 */
export function parseLocalizedNumberString(value: string): number | undefined {
  const trimmed = value.trim();
  if (!trimmed) {
    return undefined;
  }

  const normalized = normalizeLocalizedNumberString(trimmed);
  const parsed = Number.parseFloat(normalized);
  return Number.isNaN(parsed) ? undefined : parsed;
}

function normalizeLocalizedNumberString(value: string): string {
  const lastCommaIndex = value.lastIndexOf(',');
  const lastDotIndex = value.lastIndexOf('.');

  if (lastCommaIndex !== -1 && lastDotIndex !== -1) {
    if (lastCommaIndex > lastDotIndex) {
      return value.replaceAll('.', '').replaceAll(',', '.');
    }

    return value.replaceAll(',', '');
  }

  if (lastCommaIndex !== -1) {
    if (US_THOUSAND_GROUPS_PATTERN.test(value)) {
      return value.replaceAll(',', '');
    }

    return value.replaceAll(',', '.');
  }

  if (lastDotIndex !== -1 && EUROPEAN_THOUSAND_GROUPS_PATTERN.test(value)) {
    return value.replaceAll('.', '');
  }

  return value;
}
